/* AG slide-out cart (V4). Uses Shopify's Ajax Cart API + Section Rendering API. Never edits line item properties. */
(function () {
  var SECTION = 'ag-cart-drawer', busy = false, lastFocus = null;
  var root = function () { return document.querySelector('[data-ag-cart]'); };
  var onCartPage = /^\/cart\/?$/.test(location.pathname);
  function setCount(n) {
    var b = document.getElementById('cart-icon-bubble'); if (!b) return;
    var c = b.querySelector('.ag-cart-count');
    if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'ag-cart-count'; b.appendChild(c); } c.textContent = n; }
    else if (c) c.remove();
  }
  function render() {
    return fetch(location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[SECTION]; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-ag-cart]'), cur = root();
        if (!fresh || !cur) return;
        cur.querySelector('.ag-cd__panel').innerHTML = fresh.querySelector('.ag-cd__panel').innerHTML;
        var body = cur.querySelector('[data-ag-cart-body]'); setCount(body ? +body.dataset.count : 0);
      });
  }
  function open() {
    var r = root(); if (!r) return; lastFocus = document.activeElement;
    r.classList.add('is-open'); r.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('ag-cd-lock');
    var p = r.querySelector('.ag-cd__panel'); p && setTimeout(function () { p.focus(); }, 50);
  }
  function close() {
    var r = root(); if (!r) return;
    r.classList.remove('is-open'); r.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('ag-cd-lock');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function update(updates) {
    if (busy) return Promise.resolve(); busy = true; var r = root(); r && r.classList.add('is-busy');
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(render).finally(function () { busy = false; var r2 = root(); r2 && r2.classList.remove('is-busy'); });
  }
  function addVariant(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); }).then(render);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var icon = t.closest('#cart-icon-bubble');
    if (icon && root() && !onCartPage && !e.metaKey && !e.ctrlKey) { e.preventDefault(); render().then(open); return; }
    if (!root() || !root().contains(t)) return;
    if (t.closest('[data-ag-cart-close]')) { e.preventDefault(); close(); return; }
    var line = t.closest('.ag-cd__line');
    var qb = t.closest('[data-ag-qty]'), rm = t.closest('[data-ag-remove]'), add = t.closest('[data-ag-add]');
    if (add) { e.preventDefault(); add.disabled = true; addVariant(add.dataset.agAdd, 1); return; }
    if (line && (qb || rm)) {
      e.preventDefault();
      var q = rm ? 0 : Math.max(0, (+line.dataset.qty) + (+qb.dataset.agQty));
      var u = {}; u[line.dataset.key] = q;
      // keep a build's add-on lines in step with the build (same quantity, removed together)
      line.querySelectorAll('.ag-cd__addons [data-key]').forEach(function (a) { u[a.dataset.key] = q; });
      update(u);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root() && root().classList.contains('is-open')) close(); });
  // Plain (non-builder) product forms: add with Ajax and open the drawer instead of leaving the page.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!root() || !f.matches || !f.matches('form.ag-product-form') || !f.querySelector('button[name="add"]')) return;
    e.preventDefault();
    var btn = f.querySelector('button[name="add"]'); btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'error'); }); })
      .then(render).then(open)
      .catch(function () { f.submit(); })
      .finally(function () { btn.removeAttribute('aria-disabled'); });
  });
  window.agCart = { open: open, close: close, refresh: render, available: function () { return !!root() && !onCartPage; } };
})();
